import React, { useState, useEffect } from 'react';

const GenericConfig = ({ parameters, onChange }) => {
  const [jsonValue, setJsonValue] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    setJsonValue(JSON.stringify(parameters || {}, null, 2));
    setError(null);
  }, [parameters]);

  const handleChange = (e) => {
    const value = e.target.value;
    setJsonValue(value);
    try {
      const parsed = JSON.parse(value);
      setError(null);
      onChange(parsed);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <label className="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
        Parameters (JSON)
      </label>
      <textarea
        value={jsonValue}
        onChange={handleChange}
        className={`w-full h-[300px] px-3 py-2 font-mono text-xs bg-gray-900 text-green-400 rounded-lg border ${error ? 'border-red-400' : 'border-gray-700'} resize-none focus:outline-none focus:ring-1 focus:ring-violet-500`}
        spellCheck={false}
      />
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
};

export default GenericConfig;
